import React, { useState } from "react";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { Screen, TopBar } from "@/components/ui";
import { THINGS_WRONG } from "@/data/crystalsData";

export default function Wrong() {
  const { colors } = useTheme();
  const [openId, setOpenId] = useState(THINGS_WRONG[0]?.id);

  return (
    <Screen>
      <TopBar title="Things People Get Wrong 👀" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 40px" }}>
        <div style={{ color: colors.muted, fontSize: 14, lineHeight: "20px", marginBottom: 16, fontFamily: fonts.text }}>
          Common myths, confusing names and misconceptions — so you can set the record straight without being a know-it-all.
        </div>
        {THINGS_WRONG.map((w) => {
          const open = openId === w.id;
          return (
            <div key={w.id} style={{ background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 16, marginBottom: 12, overflow: "hidden" }}>
              <button data-testid={`wrong-${w.id}`} className="pressable" onClick={() => setOpenId(open ? null : w.id)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: 16, background: "transparent", border: "none", cursor: "pointer", textAlign: "left" }}>
                <div style={{ width: 42, height: 42, borderRadius: 12, background: colors.brandTertiary, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name={w.icon} size={20} color={colors.onBrandTertiary} />
                </div>
                <span style={{ flex: 1, color: colors.onSurface, fontSize: 16, fontWeight: 700, fontFamily: fonts.text }}>{w.title}</span>
                <Icon name={open ? "chevron-up" : "chevron-down"} size={20} color={colors.muted} />
              </button>
              {open ? (
                <div style={{ padding: "0 16px 16px", display: "flex", flexDirection: "column", gap: 10 }}>
                  {w.body.map((para, i) => (
                    <div key={i} style={{ color: colors.onSurfaceSecondary, fontSize: 14, lineHeight: "21px", fontFamily: fonts.text }}>{para}</div>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </Screen>
  );
}
